import { Component } from '@angular/core';

@Component({
  selector: 'app-clock-icon',
  standalone: true,
  host: { class: 'ui-icon' },
  templateUrl: './clock-icon.component.html',
  styleUrl: '../icon-base.scss'
})
export class ClockIconComponent {}
